import { z } from 'zod';

export const BiasType = z
  .enum(['Structural', 'Preference', 'Information'])
  .describe('BiasType');
export type BiasType = z.infer<typeof BiasType>;
